import React from 'react'
import { Link } from '@chakra-ui/react'

export const BackToSelectPaymentLink = ({ onClick }) => (
  <Link onClick={onClick} textAlign="center" textDecoration="underline" color="label.link" fontSize="xs" fontWeight="400" _hover={{ color: '#1E7AD4' }}>
    前のページへ戻る
  </Link>
)
